import { Avatar } from '@mui/material'
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded'
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded'

type Prop = {
  opened: Boolean
  onClick: () => void
  width?: string
  height?: string
  mx?: string
}
export default function OpenCloseButton({ opened, onClick, width, height, mx }: Prop) {
  return (
    <Avatar
      sx={{
        width: width ?? 'default',
        height: height ?? 'default',
        bgcolor: 'primary.main',
        mx: mx ?? '10px',
      }}
      onClick={onClick}>
      {opened ? (
        <ExpandLessRoundedIcon sx={{ cursor: 'pointer', padding: 0.1 }} />
      ) : (
        <ExpandMoreRoundedIcon sx={{ cursor: 'pointer', padding: 0.1 }} />
      )}
    </Avatar>
  )
}
